export default __webpack_public_path__ + "static/media/logout-box-r-fill.6a59172f.svg";